import { Injectable } from '@angular/core';

import { OfflineDelivery, DeliveryAsset, AssetGroup, TrackTypes } from '../models';
import { InboxDelivery } from '../models/inbox-delivery.model';

@Injectable()
export class HelperService {
  static cloneOfflineDelivery(delivery = <OfflineDelivery>{}) {
    return {
      ...delivery,
      offlineAudioAssets: (delivery.offlineAudioAssets || []).map((audioAsset: DeliveryAsset) => {
        const currentAsset = { ...audioAsset };
        currentAsset.types = (currentAsset.types || []).map((type: TrackTypes) => ({ ...type }));
        return currentAsset;
      }),
      assetGroups: (delivery.assetGroups || []).map((assetGroup: AssetGroup) => ({
        ...assetGroup,
      })),
    };
  }

  static cloneDelivery(delivery = <InboxDelivery>{}): InboxDelivery {
    return {
      ...delivery,
      assetGroups: (delivery.assetGroups || []).map((assetGroup: AssetGroup) => ({
        ...assetGroup,
      })),
    };
  }

  static cloneDeliveryAsset(deliveryAsset = <DeliveryAsset>{}): DeliveryAsset {
    return {
      ...deliveryAsset,
      types: (deliveryAsset.types || []).map((type: TrackTypes) => ({ ...type })),
    };
  }
}
